module.exports = __webpack_public_path__ + "img/image_placeholder_measurement.120985b6.png";